import { render } from "./OverviewContent.vue?vue&type=template&id=4eddfc36&scoped=true"
import script from "./OverviewContent.vue?vue&type=script&lang=js"
export * from "./OverviewContent.vue?vue&type=script&lang=js"

import "./OverviewContent.vue?vue&type=style&index=0&id=4eddfc36&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eddfc36"]])

export default __exports__